import { ApplicantModel } from "./applicant.model";

export class Applicant implements ApplicantModel
{
    protected _model: ApplicantModel;

    constructor(model: ApplicantModel)
    {
        this._model = model
    }

    get model() { return this._model; }

    get isInOvertime() { return this.model.isInOvertime; }

    get isReturning() { return this.model.isReturning; }

    get status() { return this.model.status; }

    get updatedAt() { return this.model.updatedAt; }

    get user() { return this.model.user; }

    get confirmedBy() { return this.model.confirmedBy; }

    get confirmedAt() { return this.model.confirmedAt; }

    get appliedAt() { return this.model.appliedAt; }

    get facilityNurse() { return this.model.facilityNurse; }

    get ncnsReportedAt() { return this.model.ncnsReportedAt; }

    get withdrawnAt() { return this.model.withdrawnAt; }

    get inviteExpiresAt() { return this.model.inviteExpiresAt; }

    get invitedAt() { return this.model.invitedAt; }

    get invitedBy() { return this.model.invitedBy; }

    get isOverlapping() { return this.model.isOverlapping; }
    
    get isOverworking() { return this.model.isOverworking; }

    get isRefilled() { return this.model.isRefilled; }
    
    get refilledUser() { return this.model.refilledUser; }

    get eta() { return this.model.eta }

    get etaLeavingAt() { return this.model.etaLeavingAt; }

    get etaStatus() { return this.model.etaStatus; }

    get etaSubmitedAt() { return this.model.etaSubmitedAt; }

}
